export default {
  __html: `<g fill="none" fill-rule="evenodd">
                <path fill="#c5c3d8" fill-rule="nonzero" d="M13.168 42.098c-1.64 0-2.968 1.342-2.968 2.997v21.099c0 5.411 4.366 9.82 9.725 9.82h59.704c5.359 0 9.725-4.409 9.725-9.82v-11.05c0-1.654-1.329-2.996-2.968-2.996-1.64 0-2.968 1.342-2.968 2.997v11.049c0 2.1-1.708 3.826-3.79 3.826H19.926c-2.081 0-3.79-1.725-3.79-3.826V48.092h70.25c1.64 0 2.969-1.342 2.969-2.997V33.776c0-5.411-4.366-9.82-9.725-9.82H19.925c-5.36 0-9.725 4.409-9.725 9.82v1.13c0 1.654 1.328 2.996 2.968 2.996 1.639 0 2.968-1.342 2.968-2.997v-1.129c0-2.1 1.708-3.826 3.789-3.826h59.704c2.08 0 3.789 1.725 3.789 3.826v8.322h-70.25z"/>
                <path d="M.04 0h99.029v100H.04z"/>
            </g>`
}



// WEBPACK FOOTER //
// ./src/app/elements/Icon/card.js